import { ElMessageBox } from 'element-plus'
import {
  deferUnpaidFeePrompt,
  isAgreementGateBlocking,
  onFlushUnpaidFeePrompt,
  clearPendingUnpaidFeePrompt,
  _notifyFeeDialogSettled,
} from '@/utils/agreementGate'

/** 湖北中医药大学 / 测试环境 TEST：线下缴费，专用文案，不展示「去缴费」 */
const HBUCM_LIKE_TENANT_IDS = ['2089559997481512960', '1976489618094170159']

function isHbucmLikeTenant() {
  try {
    return HBUCM_LIKE_TENANT_IDS.includes(String(sessionStorage.getItem('SHOPID') || ''))
  } catch (_) {
    return false
  }
}

let isShowing1003Dialog = false

/**
 * 清本地欠费缓存（session 标记 + 闸门暂存文案）。
 * 管理端标已缴后，课程列表等闸门接口成功时调用，无需重登。
 */
export function clearUnpaidFeeState() {
  try {
    sessionStorage.removeItem('hasUnpaidFee')
  } catch (_) {}
  clearPendingUnpaidFeePrompt()
}

/** 这些接口成功返回，说明当前已不欠对应阶段费，可清本地欠费标记 */
export function isFeeGateSuccessUrl(url) {
  if (!url) return false
  const u = String(url)
  return (
    u.includes('/course/student/courseList') ||
    u.includes('/enrollmentApplications/isStagePaid') ||
    u.includes('/enrollmentApplications/isFirstStagePaid') ||
    u.includes('/thesis/thesisProcessNode/getCurrentNode')
  )
}

/**
 * 论文/学位二阶段缴费闸门：其 1003 只卡学位，勿写全局欠费标记以免误拦课程。
 */
export function isThesisFeeGateUrl(url) {
  if (!url) return false
  const u = String(url)
  return (
    u.includes('/thesis/thesisProcessNode/getCurrentNode') ||
    u.includes('/enrollmentApplications/isFirstStagePaid')
  )
}

/** 当前是否在学位申请相关路由（二阶段催签仅在此场景） */
export function isDegreeOrThesisRoute() {
  try {
    const path = window.location.pathname || ''
    return /degree-application|DegreeApplication|thesis/i.test(path)
  } catch (_) {
    return false
  }
}

/**
 * 处理 1003 未缴费提示。
 * 活体/手签闸门进行中则暂存，闸门结束后再弹，保证顺序：活体 → 手签 → 缴费。
 * @param {string} message
 * @param {string} [requestUrl] 用于区分论文二阶段闸门，避免误写全局欠费标记
 */
export function handleUnpaidFeePrompt(message, requestUrl) {
  if (!isThesisFeeGateUrl(requestUrl)) {
    sessionStorage.setItem('hasUnpaidFee', 'true')
  }
  const msg = message || '您有待支付的订单'
  if (isAgreementGateBlocking()) {
    deferUnpaidFeePrompt(msg)
    return
  }
  showUnpaidFeeDialog(msg)
}

/**
 * 欠费提示弹框：仅「知道了」关闭，不展示「去缴费」。
 * 湖中医/TEST 线下缴费：文案固定为「请联系院校进行费用缴纳」。
 */
export function showUnpaidFeeDialog(message) {
  if (isShowing1003Dialog) return
  isShowing1003Dialog = true
  window.__isShowing1003Dialog = true

  const msg = isHbucmLikeTenant()
    ? '请联系院校进行费用缴纳'
    : (message || '您有待支付的订单')

  ElMessageBox.alert(msg, '提示', {
    confirmButtonText: '知道了',
    type: 'warning',
  })
    .catch(() => {})
    .finally(() => {
      isShowing1003Dialog = false
      window.__isShowing1003Dialog = false
      clearUnpaidFeeState()
      _notifyFeeDialogSettled()
    })
}

onFlushUnpaidFeePrompt((msg) => {
  showUnpaidFeeDialog(msg)
})
